import React from 'react';
import {TrashIcon} from "@heroicons/react/outline";

function DeleteButton (props)  {
    return (
        <TrashIcon onClick={props.onClick} className="bg-gray-200 opacity-70 hover:opacity-100 transition-all cursor-pointer h-6 text-red-700 rounded-md p-1"/>
    );
}

export default DeleteButton;